import * as React from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {show} from '../../../store/actions/toast';
import {getCurrentLang} from '../../../utils/i18n';

const ButtonShare = ({comic, chapter, iconOnly, className}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const user = useSelector(state => state.user);
    const idp = user && user.idp;

    const share = () => {
        navigator.clipboard.writeText(
            `${window.location.origin}/comics/${comic.friendlyName}`,
        );
        dispatch(show('Link copiado'));

        window.turner_metadata.trackAction.push({
            type: 'interaction',
            data: {
                interaction: 'comic|share link',
                domain: 'cnplus.com',
                brand: 'cartoon network',
                server: 'cnplus',
                platform: 'web',
                appname: 'app|cnplus|web',
                region: 'latam',
                country:
                    user && user.countryIsoCode && user.countryName
                        ? `${user.countryIsoCode.toLowerCase()}|${
                              user.countryName
                          }`
                        : 'not loaded',
                interactionevent: '1',
                authstate:
                    user && user.jwtToken ? 'authenticated' : 'unauthenticated',
                mvpd: idp || 'idp not loaded',
                userlang: getCurrentLang(),
                franchise: comic.show,
                contenttype: 'comics',
                contenttitle: comic.title,
                english_name: comic.englishTitle.toLowerCase(),
                sharecopy_event: '1',
                chapter_number: chapter ? String(chapter?.number) : null,
            },
        });
    };

    return (
        <Container
            className={className}
            activeScale={1.03}
            friction={10.0}
            onClick={share}
            iconOnly={iconOnly}
        >
            {!iconOnly && <ShareText>{t('comics.share')}</ShareText>}
            <Image
                src={require('../../../assets/ic_share.png')}
                iconOnly={iconOnly}
            />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    width: ${props => (props.iconOnly ? 'undefined' : '220px')};
    height: 44px;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border: solid;
    border-width: ${props => (props.iconOnly ? 0 : 3)}px;
    border-color: white;
    border-radius: 6px;
    padding: 0px 16px;
    cursor: pointer;
`;
const ShareText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    text-transform: uppercase;
    color: white;
`;

const Image = styled.img`
    width: ${props => (props.iconOnly ? '40px' : '24px')};
    height: ${props => (props.iconOnly ? '40px' : '24px')};
`;

export default ButtonShare;
